 <template>
  <b-spinner v-if="spinner" variant="success"></b-spinner>
  <a v-else title="Gnres" @click="print_gnres([item.id], true)">
    <i class="fas fa-poo ml-2"></i>
  </a>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
export default {
  props: ["item"],
  data() {
    return {
      spinner: false,
    };
  },
  methods: {
    print_gnres(orders_ids, show_modal) {
      this.spinner = true;
      axios
        .post("/api/documents/get_gnres", orders_ids)
        .then((response) => {
          this.spinner = false;
          if (response.data.erro) {
            if (show_modal == true) {
              swal({
                title: "Ops!",
                text: this.$t(
                  "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
                ),
                type: "error",
              });
            }
          } else {
            this.spinner = false;
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("GNREs geradas com sucesso!"),
                type: "success",
              });
            }
          }
        })
        .catch((error) => {
          this.spinner = false;
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
            ),
            type: "error",
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Gnres.vue